import React from 'react';
import SearchPage from './SearchPage';

export default () =>{
	return <SearchPage />

}